import { parseAnoMes } from "./parseAnoMes";

export const sortAnoMes = (anoMesArray: string[]): string[] => {
  return [...anoMesArray].sort((a, b) => {
    try {
      return parseAnoMes(a).getTime() - parseAnoMes(b).getTime();
    } catch (error: any) {
      return 0;
    }
  });
};
